import { projectTooltipByType } from '~/@pages_investing/projects/_projects_ui/project-info-tooltips/projectTooltipByType'
import { FieldContent, FieldLabel } from '~/shadcn/ui/field'
import { FormItem } from '~/shadcn/ui/form/form'
import { Switch } from '~/shadcn/ui/switch'
import { useIsCompanySetter } from './useIsCompanySetter'
import { useUser } from '~/@biz_account/useUser/useUser'

function IsCompanySetter() {
  const { user, reloadUser } = useUser()
  const { isCompany, setIsCompany } = useIsCompanySetter(
    user?.profile?.isCompany ?? false,
    reloadUser
  )

  return (
    <FormItem className="p-4 bg-gray-200 rounded-md">
      <FieldContent className="flex flex-row justify-between items-center gap-4">
        <FieldLabel htmlFor="isMarketingEnabled" className="cursor-pointer">
          <span className="text-base font-semibold leading-[26px]">
            Investujem ako podnikateľ/firma
          </span>
          {projectTooltipByType.companyRegister}
        </FieldLabel>
        <Switch
          id="isMarketingEnabled"
          checked={isCompany}
          onCheckedChange={setIsCompany}
        />
      </FieldContent>
    </FormItem>
  )
}

export { IsCompanySetter }
